export enum EnglishLevel {
  ELEMENTARY,
  PRE_INTERMEDIATE,
  INTERMEDIATE,
  UPPER_INTERMEDIATE,
  ADVANCED,
  NATIVE,
  NOT_SPECIFIED,
}
